import type { FaireProductEntity } from "../../entity_types/product";

export const p_byj8dc6ptb: FaireProductEntity = {
  token: "p_byj8dc6ptb",
  type: "product",
  name: "Friendly Frog Cardigan",
  brandToken: "b_b703e67f",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/06d2e53128f4032d747662838dbe9d79fb065664aa2995444f2e8c17c210d44c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d26e4e2b9ec0099ae1bf066255fe601518e770a653a2100a8b827c734769b63b.jpeg",
    "https://cdn.faire.com/fastly/ef6f454212c768a590ed45c12310807a20258d56feda060235bb38247e592861.jpeg",
    "https://cdn.faire.com/fastly/79304b34c111afa3dd7545759a4251508795585f9ddbec762791d828641ae59d.jpeg",
    "https://cdn.faire.com/fastly/b5547a5ad4e9a70208da2061a55bb72acadefe66e1e2a769213493e21cf406f9.jpeg",
    "https://cdn.faire.com/fastly/a18ea4eb6386f5a50cbfe8434d523efe357b67d1c20d3672050313d6acc597ce.jpeg",
    "https://cdn.faire.com/fastly/7f181f55aea13c04653879963f584541bd200e541eb2fb3a949eb7f0743723bf.jpeg",
  ],
  priceDollars: 44.34,
  description:
    "\nCardigans are hereee!! They're warm, cute, comfy, cute, soft and stylish and cute!!!\n\nThis cardigan is made of tightly knit green yarn and features frog appliques on the front. Cardigan buttons down the front with sweetest pink buttons.\n\nThese cardigans are extraaaa stretchy bc we wanted them to fit everyone.\n\nCardigans are 53% acrylic, 25% nylon, 22% polyester and 100% fun.\n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n",
  tags: [],
  msrpDollars: 88.68,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:18.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
